module.exports = __webpack_public_path__ + "static/img/2-联强国际.a15c24d6.png";